import type { RouteLocationRaw } from 'vue-router'

import { NEW_POST_ID } from '@/lib/content/post-workbench'

/** The route of a post's workbench. */
export function postRoute(postId: string): RouteLocationRaw {
  return { name: 'post', params: { id: postId } }
}

/** The route of the workbench for a post not made yet, dated `date` when given. */
export function newPostRoute(date?: string): RouteLocationRaw {
  return {
    name: 'post',
    params: { id: NEW_POST_ID },
    ...(date ? { query: { date } } : {}),
  }
}
